import { ReactComponent as NoneNewsIconSVG } from "./none-news.svg";
import { SvgIcon } from '@mui/material';

export default function IconNewsNone(props) {
  return <SvgIcon {...props} component={NoneNewsIconSVG} viewBox="0 0 25 25" />;
}